/**
 * Navigation Component
 *
 * Handles mobile menu toggle and navigation interactions
 */

export class Navigation {
  constructor(element) {
    this.nav = element;
    this.toggle = this.nav.querySelector('.menu-toggle');
    this.menu = this.nav.querySelector('.nav-menu');
    this.isOpen = false;

    this.init();
  }

  /**
   * Initialize navigation
   */
  init() {
    if (!this.toggle || !this.menu) {
      return;
    }

    this.bindEvents();
  }

  /**
   * Bind event listeners
   */
  bindEvents() {
    this.toggle.addEventListener('click', () => this.toggleMenu());

    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeMenu();
      }
    });

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
      if (this.isOpen && !this.nav.contains(e.target)) {
        this.closeMenu();
      }
    });
  }

  /**
   * Toggle menu
   */
  toggleMenu() {
    if (this.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  /**
   * Open menu
   */
  openMenu() {
    this.menu.classList.add('is-open');
    this.toggle.setAttribute('aria-expanded', 'true');
    this.isOpen = true;
    document.body.classList.add('menu-open');
  }

  /**
   * Close menu
   */
  closeMenu() {
    this.menu.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.isOpen = false;
    document.body.classList.remove('menu-open');
  }
}
